import {
  ACTIVATE_DMX_DEVICE_PRESET,
  ACTIVATE_DMX_DEVICE_PRESET_SUCCESSFUL,
  ACTIVATE_DMX_DEVICE_PRESET_FAILED,
} from './actionTypes';

const initialState = {
  activateDmxDevicePresetError: null,
  messageDmxDevicePreset: null,
  loadingActivateDmxDevicePreset: false,
};

const activateDevicePreset = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATE_DMX_DEVICE_PRESET:
      state = { ...state, loadingActivateDmxDevicePreset: true, activateDmxDevicePresetError: null };
      break;
    case ACTIVATE_DMX_DEVICE_PRESET_SUCCESSFUL:
      state = {
        ...state,
        loadingActivateDmxDevicePreset: false,
        messageDmxDevicePreset: action.payload,
        activateDmxDevicePresetError: null,
      };
      break;
    case ACTIVATE_DMX_DEVICE_PRESET_FAILED:
      state = {
        ...state,
        messageDmxDevicePreset: null,
        loadingActivateDmxDevicePreset: false,
        activateDmxDevicePresetError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default activateDevicePreset;
